import dayjs, { Dayjs } from 'dayjs'
import { PDatePickerFastChoice } from './types'

export const resolveDateFastChoice = (choice?: PDatePickerFastChoice): Dayjs => {
  const date: Dayjs = dayjs()

  switch (choice) {
    case PDatePickerFastChoice.YESTERDAY:
      return date.subtract(1, 'day')
    case PDatePickerFastChoice.TODAY:
      return date
    case PDatePickerFastChoice.TOMORROW:
      return date.add(1, 'day')
    case PDatePickerFastChoice.MONDAY_OF_LAST_WEEK:
      return date.subtract(1, 'week').startOf('week')
    case PDatePickerFastChoice.MONDAY_OF_THIS_WEEK:
      return date.startOf('week')
    case PDatePickerFastChoice.MONDAY_OF_NEXT_WEEK:
      return date.add(1, 'week').startOf('week')
    case PDatePickerFastChoice.FIRST_OF_LAST_MONTH:
      return date.subtract(1, 'month').startOf('month')
    case PDatePickerFastChoice.FIRST_OF_THIS_MONTH:
      return date.startOf('month')
    case PDatePickerFastChoice.FIRST_OF_NEXT_MONTH:
      return date.add(1, 'month').startOf('month')
    case PDatePickerFastChoice.FIRST_OF_LAST_YEAR:
      return date.subtract(1, 'year').startOf('year')
    case PDatePickerFastChoice.FIRST_OF_THIS_YEAR:
      return date.startOf('year')
    case PDatePickerFastChoice.FIRST_OF_JANUARY:
      return date.month(0).startOf('month')
    case PDatePickerFastChoice.FIRST_OF_FEBRUARY:
      return date.month(1).startOf('month')
    case PDatePickerFastChoice.FIRST_OF_MARCH:
      return date.month(2).startOf('month')
    case PDatePickerFastChoice.FIRST_OF_APRIL:
      return date.month(3).startOf('month')
    case PDatePickerFastChoice.FIRST_OF_MAY:
      return date.month(4).startOf('month')
    case PDatePickerFastChoice.FIRST_OF_JUNE:
      return date.month(5).startOf('month')
    case PDatePickerFastChoice.FIRST_OF_JULY:
      return date.month(6).startOf('month')
    case PDatePickerFastChoice.FIRST_OF_AUGUST:
      return date.month(7).startOf('month')
    case PDatePickerFastChoice.FIRST_OF_SEPTEMBER:
      return date.month(8).startOf('month')
    case PDatePickerFastChoice.FIRST_OF_OCTOBER:
      return date.month(9).startOf('month')
    case PDatePickerFastChoice.FIRST_OF_NOVEMBER:
      return date.month(10).startOf('month')
    case PDatePickerFastChoice.FIRST_OF_DECEMBER:
      return date.month(11).startOf('month')
    case PDatePickerFastChoice.IN_A_WEEK:
      return date.add(1, 'week')
    case PDatePickerFastChoice.IN_TWO_WEEKS:
      return date.add(2, 'week')
    case PDatePickerFastChoice.IN_A_MONTH:
      return date.add(1, 'month')
    case PDatePickerFastChoice.IN_HALF_A_YEAR:
      return date.add(6, 'month')
    case PDatePickerFastChoice.IN_A_YEAR:
      return date.add(1, 'year')
    default:
      return date
  }
}

export const applyDefaultTime = (date: Dayjs, defaultTime?: string): Dayjs => {
  if (!defaultTime) {
    return date.tz().withCurrentTime()
  }

  const parsedTime = dayjs(defaultTime, 'HH:mm', true)

  if (!parsedTime.isValid()) {
    return date.tz().withCurrentTime()
  }

  return date.tz().hour(parsedTime.hour()).minute(parsedTime.minute()).second(0).millisecond(0)
}
